module.exports = __webpack_public_path__ + "static/media/site1x1200.8a9b1061.png";